import Factory from 'factories/all';

export default function createIncomingWebFormItem(incomingWebForm, agent) {
  return Factory.build('WebFormItemWithDefaults', {
    content: {
      content: incomingWebForm.content,
    },
  });
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/communication_simulation_service/create_incoming_web_form_item.js